module.exports = __webpack_public_path__ + "cuttingLineSlide.webp?516ce9538df3aeced63e15f538241b5d";